<template>
  <div>
    <modal
      :open="open"
      :title="trans('attendance_list.comment_for', { name: studentName })"
      style="text-align:left; "
      @close="closeModal"
    >
      <div
        v-for="remark in remarks"
        class="remark"
      >
        <span
          class="fa fa-trash pull-right"
          @click="openDeleteModal(remark)"
        />
        <span class="pull-right remark-modal">
          {{ remark.date }}</span>
        <br>
        <span class="remark-span">{{ remark.remark }}</span>
      </div>

      <form>
        <div
          class="form-group"
          style="text-align:left;"
        >
          <label :for="uniqueIdRemark">{{ trans('attendance_list.new_remark') }}</label>
          <textarea
            :id="uniqueIdRemark"
            v-model="remark"
            class="form-control"
            autofocus
            placeholder="..."
          />
        </div>
      </form>
      <button
        type="button"
        class="btn btn-success pull-right"
        @click="addRemark"
      >
        {{ trans('core.save') }}
      </button>
      <br style="clear:both;">
    </modal>

    <modal
      :open="openDelete"
      :title="trans('core.delete_object', { object: trans('core.remark') })"
      style="text-align:left;"
      @close="closeDeleteModal"
    >
      <span>{{ trans('attendance_list.delete_remark_question') }}</span>
      <div
        v-if="remarkToDelete != null"
        class="remark"
      >
        <span class="pull-right remark-modal">
          {{ remarkToDelete.date }}
        </span>
        <br>
        <span class="remark-span">{{ remarkToDelete.remark }}</span>
      </div>
      <button
        type="button"
        class="btn btn-primary pull-right"
        @click="deleteRemark"
      >
        {{ trans('core.delete_object', { object: trans('core.remark') }) }}
      </button>
      <br style="clear:both;">
    </modal>
  </div>
</template>

<script>

import Modal from './Modal.vue'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'AttendanceListRemarkModals',

  components: { Modal },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    studentId: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      open: false,
      remark: null,
      openDelete: false,
      remarkToDelete: null,
      uniqueIdRemark: 'remark_' + this.studentId,
    }
  },

  computed: {
    studentName () {
      return this.$store.state.attendancelist.students[this.studentId].attributes.name
    },
    remarks () {
      let remarks = []
      let self = this
      let contexts = this.$store.state.attendancelist.students[this.studentId].relationships.contexts.data
      contexts.forEach(function (item) {
        let context = self.$store.state.attendancelist.contexts[item.id]
        if (context.attributes.type === 'free_remark' && context.attributes.remark) {
          remarks.push(context.attributes.remark)
        }
      })
      return remarks
    },
  },

  watch: {},

  mounted () {
    this.openModal()
  },

  methods: {
    openModal () {
      this.open = true
    },

    closeModal () {
      this.remark = null
      this.open = false
      this.$emit('closed-modal')
    },

    openDeleteModal (remark) {
      this.remarkToDelete = remark
      this.openDelete = true
    },

    closeDeleteModal () {
      this.remarkToDelete = null
      this.openDelete = false
    },

    addRemark () {
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        return this.$store.dispatch('change_context', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentId: this.studentId,
          contextType: 'free_remark',
          checked: false,
          remark: this.remark,
        }).then(() => {
          this.closeModal()
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.$store.dispatch('change_loading', { loading: false })
      })
    },

    deleteRemark () {
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        return this.$store.dispatch('change_context', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentId: this.studentId,
          contextType: 'free_remark',
          checked: true,
          remark: this.remarkToDelete,
        }).then(() => {
          this.closeDeleteModal()
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.$store.dispatch('change_loading', { loading: false })
      })
    },
  },
}
</script>

<style>

    .remark {
        text-align: left;
        background-color: #dde7ff;
        border: 5px #25167a;
        border-style: hidden hidden hidden solid;
        margin-bottom: 15px;
        padding: 10px;
    }

    .fa-icon-badge:after {
        content: attr(data-count);
        font-family: Roboto, Helvetica, Arial, sans-serif;
        position: absolute;
        background: rgba(0, 0, 0, 1);
        height: 1.3rem;
        top: -0.2rem;
        right: -0.4rem;
        width: 1.3rem;
        text-align: center;
        line-height: 1.1rem;
        font-size: 1.1rem;
        border-radius: 50%;
        color: white;
        border: 1px solid rgba(0, 0, 0, 1);
    }

    .remark-modal {
        font-style:italic;
        font-size: 12px;
        padding-right: 5px;
        margin-top: -1px;
    }

    .remark-span {
        padding-right:10px;
        margin-right:10px;
    }

</style>
